import { render, staticRenderFns } from "./RegisteredNumberOfPeopleAndDogs.vue?vue&type=template&id=105bb07c&scoped=true&"
import script from "./RegisteredNumberOfPeopleAndDogs.vue?vue&type=script&lang=js&"
export * from "./RegisteredNumberOfPeopleAndDogs.vue?vue&type=script&lang=js&"
import style0 from "./RegisteredNumberOfPeopleAndDogs.vue?vue&type=style&index=0&id=105bb07c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105bb07c",
  null
  
)

export default component.exports